export const MAPBOX_ACCESS_KEY = 'pk.eyJ1Ijoic2ltb25lY2hlaWRlIiwiYSI6ImNqeGx5NmU5bjBhZGczdG50N2t4c20yangifQ.1VoPfDI1X6rAW8iYn4x5fA';
export const MAPBOX_STYLE = 'mapbox://styles/felipelorenzo/ck9khgigq14ay1inychjvw25n';
export const MAX_DISTANCE_TO_AUTOFOCUS = 2000;
export const DISTANCE_TO_INTERACTIVE = 50;
export const NUM_CHALLENGE_POINTS = 5;
export const NUM_QUESTIONS_BY_POINT = 3;
export const POINTS_CHECKPOINT = 10;
export const POINTS_CHALLENGE = 25;
export const POINTS_PICTURE = 25;
